// Where to land after signing in — the web half.
//
// The validation lives in portal-core because both platforms need the same
// rules; only the storage is local. localStorage rather than router state
// because the round trip usually crosses browser contexts: the link is tapped
// inside WhatsApp\'s in-app browser, which can be torn down and reopened
// between the bounce and the redemption.

import { isSafeReturnPath, isWorthRemembering } from '@invoiceflow/portal-core';

const KEY = 'portal_return_path';

export function rememberReturnPath(path: string): void {
  if (!isWorthRemembering(path)) return;
  try {
    localStorage.setItem(KEY, path);
  } catch {
    // Private browsing, or storage disabled — the customer lands on the
    // dashboard instead. Not worth failing a login over.
  }
}

/** Reads and clears in one step, so a stale path cannot hijack a later login. */
export function takeReturnPath(): string | null {
  try {
    const path = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
    return path && isSafeReturnPath(path) ? path : null;
  } catch {
    return null;
  }
}
